//logos
import full_b_por from "../misc/logos/vb_por.png";
import nome_p_por from "../misc/logos/nome_p_por.png";
import nome_b_por from "../misc/logos/nome_b_por.png";
import nome_p_eng from "../misc/logos/nome_p_eng.png";
import nome_b_eng from "../misc/logos/nome_b_eng.png";
import mini from "../misc/logos/mini.png";
import arrow_up from "../misc/logos/up.png";
import joia from "../misc/logos/joia.png";
import relogio from "../misc/logos/relogio.png";
import whatsapp from "../misc/logos/whatsapp.png"
import instagram from "../misc/logos/instagram.png"
import facebook from "../misc/logos/facebook.png"
import youtube from "../misc/logos/youtube.png";
import alianca from "../misc/logos/alianca.jpg";

//brands
import audemars_piguet from "../misc/simbols/audemars_piguet.png";
import cartier from "../misc/simbols/cartier.png";
import casio from "../misc/simbols/casio.png";
import montblanc from "../misc/simbols/montblanc.png";
import omega from "../misc/simbols/omega.png";
import patek_philippe from "../misc/simbols/patek_philippe.png";
import piaget from "../misc/simbols/piaget.png";
import rolex from "../misc/simbols/rolex.png";
import seiko from "../misc/simbols/seiko.png";
import tag_heuer from "../misc/simbols/tag_heuer.png";
import vacheron_constantin from "../misc/simbols/vacheron_constantin.png"
import jaeger_lecoultre from "../misc/simbols/jaeger_lecoultre.png"
import iwc_schaffhausen from "../misc/simbols/iwc_schaffhausen.png"
import breitling from "../misc/simbols/breitling.png"
import hublot from "../misc/simbols/hublot.png"
import zenith from "../misc/simbols/zenith.avif"
import panerai from "../misc/simbols/panerai.png"
import breguet from "../misc/simbols/breguet.png"
import chopard from "../misc/simbols/chopard.png"

//images
import inicio from "../misc/placeholders/inicio.jpeg";
import aprendizado from "../misc/placeholders/watch-detail.webp";
import o_relojoeiro from "../misc/placeholders/o_relojoeiro.jpeg";
import rest_relogio from "../misc/placeholders/restauração_relogios.jpg"
import analise from "../misc/placeholders/analise.jpg";
import recepcao from "../misc/placeholders/recepcao.jpg";
import concerto from "../misc/placeholders/concerto.jpg";
import conclusao from "../misc/placeholders/conclusao.jpeg";
import orcamento from "../misc/placeholders/orcamento.jpg";
import pecas from "../misc/placeholders/pecas.jpeg";
import bateria from "../misc/placeholders/bateria.jpg";
import bracelete from "../misc/placeholders/bracelete.jpg";
import prova from "../misc/placeholders/prova.png";
import marca from "../misc/placeholders/marca.jpg";
import rest_joia from "../misc/placeholders/joia.jpg"

let date: number = new Date(Date.now()).getFullYear();

export const data = {
    phone: "48988504224",
    phone2: "(48) 98850-4224",
    cep: "88040-400",
    email: "relojoeirowinderpablo@gmail.com",
    instagram: "relojoeirowinderpablo",
    youtube_link: "https://www.youtube.com/@relojoeirowinderpablo",
    instagram_link: "https://instagram.com/relojoeirowinderpablo",
    facebook_link: "https://www.facebook.com/RelojoeiroWinderPablo",
    map_link:"https://www.google.com/maps?ll=-27.593915,-48.523123&z=14&t=m&hl=en&gl=US&mapclient=embed&q=Rua:+Desembargador+Vitor+Lima,+n.%C2%BA+260++Complemento:+7%C2%B0+andar,+sala+715+Bairro:+Trindade",
    instagram_token: "IGAAeSq8cS06VBZAE9NamxCUnUtUVFvMURmQXA1T1ZApNUF1WTdyN1VGUW93WDR3RlZAyZA19fRG41OVZA3Uk5HUVRCNmg4OEc0RERhY0VPMXBVNk9iSlQ1YnJFaTNiMHN0MElwZA25kYWNXQWVxUy1Yb3NhZAENGbC1abTY3TnRoUnEyTQZDZD",
    slider_time: 2000,
    adress: "Rua: Desembargador Vitor Lima, n.º 260",
    loc: "7° andar, sala 715",
    city: "Florianópolis - Santa Catarina",
    square:"Trindade",
    place:"Madinson Center"
}


export const logos = {
    full_b_por,
    nome_b_eng,
    nome_p_eng,
    nome_b_por,
    nome_p_por,
    mini,
    arrow_up,
    relogio,
    joia,
    whatsapp,
    instagram,
    alianca,
    facebook,
    youtube
}

export const images = {
    inicio,
    aprendizado,
    o_relojoeiro,
    analise,
    recepcao,
    concerto,
    conclusao,
    orcamento,
    pecas,
    bateria,
    bracelete,
    prova,
    marca,
    alianca
}

export const items = {
    whatsapp: "https://wa.me/55" + data.phone,
    desc: ["Relojoeiro especializado com ", " anos de experiência, situado em Florianópolis e atendendo todo o Brasil"],
    date,
    years: date - 2007,
    steps: [
        {
            title: "Recepção",
            desc: "Registro e inspeção inicial do relógio, conferindo condições gerais e histórico de uso junto ao cliente.",
            image: recepcao,
            list: [
                "Check-in e identificação do modelo",
                "Inspeção visual de caixa, vidro e pulseira",
                "Coleta de informações sobre sinais e ruídos",
                "Verificação de estanqueidade inicial"
            ]
        },
        {
            title: "Análise",
            desc: "Diagnóstico detalhado do movimento e componentes internos, avaliando desgastes, ajustes e falhas mecânicas.",
            image: analise,
            list: [
                "Desmontagem parcial do movimento para inspeção",
                "Teste de precisão em cronocomparador",
                "Avaliação de desgaste em peças críticas",
                "Relatório de condições e necessidades"
            ]
        },
        {
            title: "Orçamento Completo",
            desc: "Apresentação de laudo técnico e estimativa de custos, incluindo peças originais e prazos de execução.",
            image: orcamento,
            list: [
                "Laudo técnico com descrição dos serviços",
                "Estimativa de valor de peças e mão de obra",
                "Definição de prazo de entrega"
            ]
        },
        {
            title: "Reparação",
            desc: "Execução dos serviços autorizados, utilizando técnicas especializadas e materiais de alta qualidade.",
            image: concerto,
            list: [
                "Substituição e ajuste de componentes afetados",
                "Limpeza ultrassônica e lubrificação precisa",
                "Testes de resistência à água e funcionalidade"
            ]
        },
        {
            title: "Conclusão",
            desc: "Controle de qualidade final, polimento estético e entrega com orientações de uso e garantia técnica.",
            image: conclusao,
            list: [
                "Teste final de cronometria e estanqueidade",
                "Polimento e acabamento geral",
                "Entrega ao cliente com certificado e garantia"
            ]
        }
    ],
    services: [
        {
            "title": "Serviços de Manutenção e Revisão",
            "desc": "",
            "image": pecas,
            "list": [
                ["Revisão completa (manutenção preventiva):"," desmontagem total do mecanismo, limpeza ultrassônica, lubrificação e montagem com ajustes finos."],
                ["Lubrificação de movimento:"," aplicação de óleos específicos nos pontos de atrito do movimento."],
                ["Limpeza de caixa e pulseira:"," uso de banho ultrassônico para remover sujeiras e oxidações."],
                ["Verificação e ajuste de precisão (cronômetro):"," uso de cronocomparador para regular o tempo com exatidão."],
                ["Troca de junta e vedação:"," substituição de borrachas de vedação para manter o relógio resistente à água."]
            ]
        },
        {
            "title": "Consertos e Reparos",
            "desc": "",
            "image": rest_relogio,
            "list": [
                ["Troca de vidro:"," substituição do cristal (vidro) danificado, seja ele de acrílico, mineral ou safira."],
                ["Substituição de coroa e hastes:"," reparo ou troca do botão de ajuste de horas e sua haste."],
                ["Conserto de botões e mostradores:"," reparo de botões danificados e realinhamento do mostrador."],
                ["Troca de ponteiros:"," substituição ou recolocação de ponteiros soltos ou danificados."],
                ["Soldas em caixa e pulseira metálica:"," reparos estruturais em relógios metálicos."]
            ],

        },
        {
            "title": "Serviços de Bateria e Energia",
            "desc": "",
            "image": bateria,
            "list": [
                ["Troca de bateria:","Remoção da bateria antiga e instalação de nova, com tetes de vedação e funcionamento."],
                ["Verificação de consumo corrente:","Análise do circuito eletrõnico do relógio para verificar falhas."],
                ["Reparo de módulos de relógios digitais:","Conserto de circuitos eletrônicos e displays."]
            ]
        },
        {
            "title": "Ajustes e Personalização",
            "desc": "",
            "image": bracelete,
            "list": [
                ["Ajuste de pulseira (remover ou adicionar elos):","Adequação do tamanho ao pulso do cliente."],
                ["Troca de pulseiras e fechos:","Substituição de partes danificadas ou personalização do estilo."],
                ["Polimento de caixa e pulseira:","Restauração do brilho e eliminação de riscos superficiais."],
                ["Gravação personalizada:","Inclusão de nomes, datas ou frases no fundo da caixa."]
            ]
        },
        {
            "title": "Serviços Especiais",
            "desc": "",
            "image": prova,
            "list": [
                ["Teste de estanqueidade (teste de vedação):","Uso de equipamentos para garantir resistência à água."],
                ["Autenticação e avaliação técnica:","verificação de originalidade e análise técnica para revenda ou seguro."],
                ["Restauração de relógios antigos ou vintages:","recuperação estética e mecânica, mantendo originalidade."],
                ["Conversão de relógios mecânicos para quartz (ou vice-versa):","em casos especiais e com adaptações específicas."],
                ["Instalação de pulseiras de couro sob medida:","Para relógios de coleção ou raros."]
            ]
        },
        {
            "title": "Atendimento ao Cliente",
            "desc": "Experiência premium do primeiro contato até a entrega, pautada em transparência, segurança e conveniência.",
            "image": marca,
            "list": [
                ["","Orçamento detalhado"],
                ["","Coleta e entrega"],
                ["","Atendimento personalizado"]
            ]
        },
        {
            "title": "Serviços de Joalheria",
            "desc": "",
            "image": rest_joia,
            "list": [
                ["Confecção Sob Medida:","Joalheria personalizada."],
                ["Restauração de peças:","Antigas ou danificadas."],
                ["Manutenção Preventiva e Corretiva",""],
                ["Polimento e Reacabamento profissional",""],
            ]
        }
    ],

    details: [
        {
            "title": "Serviços de Manutenção e Revisão",
            "description": "Programas completos de cuidado preventivo e corretivo, concebidos para conservar a integridade mecânica e a precisão cronométrica dos seus relógios, sejam eles de alta relojoaria mecânica ou de quartzo sofisticado.",
            "subs": [
                {
                    "title": "Revisão Completa",
                    "description": "Desmontagem de todos os componentes, limpeza ultrassônica em vários estágios, inspeção de desgaste, substituição de peças críticas, lubrificação com óleos sintéticos de última geração, remontagem e testes de marcha em cronômetro digital por 24 horas para aferir estabilidade do ritmo.",
                    "topics": [
                        ["Desmontagem total do mecanismo:"," o relojoeiro desmonta cada componente do movimento (engrenagens, eixos, molas, parafusos, etc.)."],
                        ["Limpeza ultrassônica:"," as peças são colocadas em uma máquina de limpeza com líquidos especiais que removem resíduos de óleo antigo, poeira e oxidação."],
                        ["Inspeção de peças:"," verifica-se se há desgaste, corrosão ou danos nas engrenagens e rolamentos."],
                        ["Lubrificação:"," aplicação de óleos específicos em pontos exatos do movimento, usando ferramentas de precisão (importante para reduzir o atrito e prolongar a vida útil)."],
                        ["Montagem e regulagem:"," o movimento é remontado com cuidado e testado para garantir que está funcionando dentro dos padrões de precisão do fabricante."],
                        ["Testes de funcionamento:"," o relógio é colocado em um cronocomparador para ajustar a precisão (mais usado em mecânicos)."],
                        ["Lubrificação de Movimento :"," Aplicação precisa de óleo sintético e graxa de alta performance em pontos de atrito calibrados, usando ferramentas de microdosagem que evitam excesso lubrificante e garantem fluidez ao conjunto."]

                    ]
                },
                {
                    "title": "Limpeza de Caixa e Pulseira",
                    "description": "Processo em banho ultrassônico com solventes específicos, seguido de escovação manual com cerdas macias e secagem em cabine, removendo resíduos de suor, poeira e corrosões sem danificar metais preciosos."
                },
                {
                    "title": "Verificação e Ajuste de Precisão (Cronômetro)",
                    "description": "Avaliação de ganho ou perda de segundos por dia em cronocomparador profissional, com regulagem micrométrica para manter variação inferior a ±5 segundos diários em movimentos mecânicos."
                },
                {
                    "title": "Troca de Juntas e Vedação",
                    "description": "Substituição de juntas de borracha nitrílica e vedações ultratécnicas, seguida de teste de pressão positiva e negativa em equipamento de estanqueidade, garantindo resistência a até 10 ATM."
                }
            ]
        },
        {
            "title": "Consertos e Reparos",
            "description": "Serviços especializados de correção e restauração, atuando em defeitos mecânicos, estruturais ou estéticos para preservar valor e funcionalidade.",
            "subs": [
                {
                    "title": "Troca de Vidro",
                    "description": "Remoção criteriosa do cristal danificado e instalação de vidro acrílico, mineral ou safira de alta dureza, com selagem hermética e acabamento polido.",
                    "topics": [
                        ["O que é:"," Substituição do cristal do relógio (acrílico, mineral ou safira) quando está riscado, trincado ou quebrado."],
                        ["Processo:"," O técnico remove o vidro danificado, limpa a área de encaixe e instala o novo cristal com a vedação adequada."]
                    ]
                },
                {
                    "title": "Substituição de Coroa e Hastes",
                    "description": "Desinstalação da coroa e haste originais, encaixe de componentes compatíveis, testes de rotação e vedação, assegurando uniformidade na regulagem de horas.",
                    "topics": [
                        ["O que é:"," Troca da coroa (botão de ajuste das horas) e da haste (barra que liga a coroa ao mecanismo)."],
                        ["Causas comuns:"," Coroa quebrada, desgaste da rosca ou haste torta."],
                        ["Importância:"," Essencial para a regulagem de hora e para manter a vedação contra água."]
                    ]
                },
                {
                    "title": "Conserto de Botões e Mostradores",
                    "description": "Desmontagem dos controles de função, limpeza de contatos elétricos ou mecânicos, reposicionamento ou troca de mostradores, com ajuste de profundidade e alinhamento.",
                    "topics": [
                        ["Botões:"," Reparo de botões de cronômetro que travam ou não funcionam."],
                        ["Mostrador:"," Reposicionamento ou substituição de mostradores desalinhados, soltos ou danificados."]
                    ]
                },
                {
                    "title": "Troca de Ponteiros",
                    "description": "Retirada de ponteiros danificados, verificação do centro do disco, instalação de ponteiros novos alinhados e teste de rotação para evitar atritos frontais.",
                    "topics": [
                        ["O que é:"," Substituição de ponteiros quebrados, oxidados ou tortos."],
                        ["Cuidado técnico:"," Evita danos ao mostrador e mantém o alinhamento correto com os marcadores de tempo."]
                    ]
                },
                {
                    "title": "Soldas em Caixa e Pulseira Metálica",
                    "description": "Soldagem TIG ou micro-soldagem em estruturas de aço inoxidável, titânio ou ouro, seguida de polimento localizado para recuperar resistência e uniformidade estética.",
                    "topics": [
                        ["Para que serve:"," Corrigir quebras ou folgas em pulseiras e fechos metálicos."],
                        ["Técnica:"," Usa-se solda fria ou a laser, dependendo da liga metálica e acabamento original."]
                    ]
                }
            ]
        },
        {
            "title": "Serviços de Bateria e Energia",
            "description": "Soluções especializadas para relógios de quartzo e digitais, focadas na manutenção do circuito eletrônico e na autonomia ideal.",
            "subs": [
                {
                    "title": "Troca de Bateria",
                    "description": "Remoção da célula exaurida e reposição por bateria de longa duração, seguida de teste de carga e vedação em bancada pressurizada."
                },
                {
                    "title": "Verificação de Consumo de Corrente",
                    "description": "Medição de consumo em miliampères com multímetro de alta precisão, identificação de picos anômalos e diagnóstico de possíveis curtos ou drenos internos."
                },
                {
                    "title": "Reparo de Módulos Digitais",
                    "description": "Diagnóstico e substituição de circuitos integrados, reparo de trilhas e contatos de display, calibragem de botões e restauração completa das funções eletrônicas."
                }
            ]
        },
        {
            "title": "Ajustes e Personalização",
            "description": "Serviços sob medida que elevam o conforto e a identidade do proprietário, adaptando seu relógio ao estilo e às dimensões ideais.",
            "subs": [
                {
                    "title": "Ajuste de Pulseira (Elos)",
                    "description": "Remoção ou inserção de elos com pinos de segurança, conferência de simetria e teste de encaixe, garantindo conforto sem folgas indesejadas."
                },
                {
                    "title": "Troca de Pulseiras e Fechos",
                    "description": "Substituição de braceletes em couro, borracha ou metal, instalação de fechos deployant ou borboleta, com adaptação de encaixe e acabamento artesanal."
                },
                {
                    "title": "Polimento de Caixa e Pulseira",
                    "description": "Processo em quatro etapas: lixamento fino, polimento bruto, polimento fino e aplicação de proteção, restaurando totalmente o acabamento original."
                },
                {
                    "title": "Gravação Personalizada",
                    "description": "Inscrições a laser de alta definição no fundo, laterais ou fivela, com controle de profundidade e acabamento sem rebarbas."
                }
            ]
        },
        {
            "title": "Serviços Especiais",
            "description": "Atendimentos técnicos de alta complexidade e projetos personalizados, voltados à preservação histórica, testes rigorosos e adaptações únicas.",
            "subs": [
                {
                    "title": "Teste de Estanqueidade (Vedação)",
                    "description": "Avaliação em máquina de vácuo e pressão, simulando profundidades de até 100 metros, seguido de inspeção visual de selos e juntas."
                },
                {
                    "title": "Restauração de Relógios Antigos ou Vintages",
                    "description": "Serviço completo de recuperação mecânica e estética, usando peças de época sempre que possível e técnicas artesanais tradicionais."
                },
                {
                    "title": "Conversão Mecânico ↔ Quartz",
                    "description": "Projeto de engenharia interna para substituir o calibre original, com adaptações de caixa e ponteiro, garantindo funcionamento perfeito."
                },
                {
                    "title": "Pulseiras Sob Medida",
                    "description": "Confeccionadas artesanalmente em couro curtido vegetal ou metais nobres, com design exclusivo e acabamento sob medida para cada modelo."
                }
            ]
        },
        {
            "title": "Atendimento ao Cliente",
            "description": "Assistência personalizada antes, durante e após o serviço, fundamentada em transparência, confiança e conveniência de alto padrão.",
            "subs": [
                {
                    "title": "Orçamento Técnico Detalhado",
                    "description": "Relatório completo com diagnóstico, plano de ação, peças necessárias, cronograma e custos discriminados, sem compromisso."
                },
                {
                    "title": "Coleta e Entrega (serviço opcional)",
                    "description": "Logística premium com coleta em domicílio ou escritório, transporte seguro, seguro incluso e rastreamento em tempo real."
                },
                {
                    "title": "Garantia dos Serviços Prestados",
                    "description": "Cobertura de 3 a 12 meses conforme o serviço, com suporte técnico prioritário e reavaliação gratuita em caso de anomalias."
                }
            ]
        },
        {
            "title": "Serviços de Joalheria",
            "description": "Desde pequenos ajustes até restauração completa de sua joia, com técnicas refinadas e materiais nobres para garantir acabamento impecável.",
            "subs": [
                {
                    "title": "Confecção Sob Medida (Joalheria Personalizada)",
                    "description": "Design exclusivo com atendimento personalizado.",
                    "topics":[
                        ["","Desenvolvimento de peças a partir de ideias ou esboços do cliente."],
                        ["","Modelagem em cera ou 3D (CAD) para aprovação prévia."],
                        ["","Escolha criteriosa de metais nobres (ouro 18k, platina) e gemas naturais."],
                        ["","Cravação artesanal ou tecnológica com precisão máxima."],
                        ["","Acabamento de alto padrão com controle de qualidade rigoroso."]
                    ]
                },
                {
                    "title": "Manutenção Preventiva e Corretiva",
                    "description": "",
                    "topics":[
                        ["","Reaperto de garras e cravações para evitar perda de pedras."],
                        ["","Limpeza profunda por ultrassom e polimento fino."],
                        ["","Verificação periódica da integridade estrutural da peça."],
                        ["","Lubrificação de fechos e partes móveis (ex. pulseiras articuladas)."],
                        ["","Ajuste de medidas (aneis, alianças, braceletes)."],

                    ]
                },
                {
                    "title": "Restauração de Peças Antigas ou Danificadas",
                    "description": "",
                    "topics":[
                        ["","Recuperação de joias de alto valor afetivo ou histórico."],
                        ["","Reposição de gemas perdidas com seleção compatível em qualidade e corte."],
                        ["","Reconstituição de partes faltantes com técnicas tradicionais e modernas."],
                        ["","Soldagem especializada em ouro e platina sem alterar o design original."],
                        ["","Preservação do estilo original com intervenções discretas."]
                    ]
                },
                {
                    "title": "Polimento e Reacabamento Profissional",
                    "description": "",
                    "topics":[
                        ["","Polimento técnico para remoção de riscos superficiais."],
                        ["","Reacabamento com diferentes texturas (acetinado, escovado, espelhado)."],
                        ["","Rebanho de peças de ouro branco com ródio de alta pureza."]
                    ]
                }
            ]
        }
        
    ],
    objectives: [
        {
            title: "Excelência em Alta Relojoaria e Joalheria",
            desc: "Especialistas em manutenção, compra, venda e curadoria de peças exclusivas. Trabalhamos com as marcas mais renomadas do mundo, oferecendo um serviço à altura de cada detalhe."
        },
        {
            title: "Autenticidade e Procedência",
            desc: "Todas as peças utilizadas em reparos ou substituições são originais, adquiridas diretamente de fornecedores certificados. Valorizamos a autenticidade como princípio inegociável."
        },
        {
            title: "Atendimento Personalizado",
            desc: "Cada cliente é único — por isso, oferecemos um atendimento sob medida, com total atenção às suas necessidades, expectativas e preferências."
        },
        {
            title: "Tradição e Confiança",
            desc: "Com anos de experiência no mercado de alta relojoaria e joalheria, construímos uma reputação baseada na confiança, no conhecimento técnico e na paixão por peças excepcionais."
        }
    ]
}

export const timelineData = [

    {
        year: "2007",
        title: "O início",
        company: "Tradição de Família",
        description: ["Desde dos meus 14 anos, atuo como relojoeiro. Tenho uma vasta experiência de ", items.years, " anos nesse ramo, sendo o terceiro geração da minha família a se dedicar a essa profissão. Tudo começou quando aprendi com meu avô, um renomado mestre relojoeiro chamado Olívio Ben-Hur Proença. Ele me transmitiu todos os conceitos fundamentais, desde a simples troca de pinos, pilhas, pulseiras e vidros, até   revisões completas de relógios mecânicos de corda e automáticos, além de técnicas de polimento e  vedação."],
        image: images.inicio,
        icon: "I"
    },
    {
        year: "2009",
        title: "Aprimoramento",
        company: "Experiência profissional",
        description: "Em seguida, continuei meu aprendizado com meu segundo mestre relojoeiro, meu tio Denilson Proença, que trabalha na Europa em assistências técnicas autorizadas de diversas marcas de relógios de luxo.Foi ele quem me introduziu ao universo da relojoaria de alto padrão e alta qualidade.",
        image: images.aprendizado,
        icon: "II"
    },
    {
        year: items.date,
        title: "Hoje",
        company: "Winder Pablo Relojoeiro",
        description: ["Atuamos na assistência técnica especializada localizada na " ,data.adress, ", ",data.loc,", ",data.city ],
        image: images.marca,
        icon: "III"
    }
];

export const brands = [
    { image: audemars_piguet, name: "Audemars Piguet" },
    { image: rolex, name: "Rolex" },
    { image: cartier, name: "Cartier" },
    { image: montblanc, name: "Montblanc" },
    { image: omega, name: "Omega" },
    { image: patek_philippe, name: "Patek Philippe" },
    { image: piaget, name: "Piaget" },
    { image: seiko, name: "Seiko" },
    { image: tag_heuer, name: "Tag Heuer" },
    { image: casio, name: "Casio" },
    { image: vacheron_constantin, name: "Vacheron Constantin" },
    { image: jaeger_lecoultre, name: "Jaeger-LeCoultre" },
    { image: iwc_schaffhausen, name: "IWC Schaffhausen" },
    { image: breitling, name: "Breitling" },
    { image: hublot, name: "Hublot" },
    { image: zenith, name: "Zenith" },
    { image: panerai, name: "Panerai" },
    { image: breguet, name: "Breguet" },
    { image: chopard, name: "Chopard" }
];
